<header class="top-navigation" role="banner" aria-label="Top navigation">
  <nav class="top-navigation__desktop-links" aria-label="Primær navigation">
    <ul class="top-navigation__list" role="list">
      @for (item of menuItems; track item) {
      <li class="top-navigation__item" role="listitem">
        <a
          class="top-navigation__link"
          [routerLink]="item.route"
          routerLinkActive="top-navigation__link--active"
          [ariaCurrentWhenActive]="'page'"
          [featureHighlight]="item.featureHighlight"
        >
          <mat-icon
            class="top-navigation__icon"
            [svgIcon]="item.icon"
            aria-hidden="true"
          ></mat-icon>
          <span class="top-navigation__label">{{ item.label }}</span>
        </a>
      </li>
      }
    </ul>
  </nav>
  <nav class="top-navigation__menu" aria-label="Brugermenu">
    <service-pro-user-menu
      [indstillinger]="indstillinger"
      [aktuelBruger]="aktuelBruger"
      [aktuelForsyning]="aktuelForsyning"
    ></service-pro-user-menu>
  </nav>
</header>
